import { Box, FormHelperText } from '@mui/material';

import { Text } from 'common';

export function X12MessageEventFormFields() {
  return (
    <Box>
      <Text>No configuration required</Text>
      <FormHelperText>Extract X12 message event from Notable databases.</FormHelperText>
    </Box>
  );
}
